import { Tooltip } from '@mui/material'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import CopyIcon from 'src/assets/images/ic_copy_link.svg'
import * as colors from 'src/ui-kit/colors/colors'
import { useTimeoutState } from 'src/components/app/utils/hooks/useTimeoutState'
import { copyToClipboard } from 'src/utils/copyToClipboard/copyToClipboardUtils'
import { fontSecondary } from 'src/ui-kit/fonts/fontFamily'

type Props = {
    isHighlighted?: boolean
    value: string
    children: any
}

export default function CopyButton({ isHighlighted = true, value, children }: Props) {
    const [copied, setCopied] = useTimeoutState(false, 2500)

    const handleCopy = () => {
        copyToClipboard(value)
        setCopied(true)
    }

    return (
        <Tooltip
            title={'Copied to clipboard'}
            onClose={() => setCopied(false)}
            open={copied}
            leaveDelay={250}
            slotProps={{
                tooltip: {
                    sx: {
                        bgcolor: '#FFFFFF',
                        color: colors.green,
                        height: '10px',
                        fontSize: '10px',
                        fontFamily: 'Montserrat, monospace',
                    },
                },
            }}
        >
            <CopyButtonWrapper $isHighlighted={isHighlighted}>
                {children}
                <CopyImg data-testid={'copy-button'} src={CopyIcon} onClick={handleCopy} alt='' />
            </CopyButtonWrapper>
        </Tooltip>
    )
}

const CopyImg = styled.img`
    cursor: pointer;
    height: 26px;
    width: 26px;
    margin-left: 10px;
`

const CopyButtonWrapper = styled.div<{ $isHighlighted: boolean }>`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    ${({ $isHighlighted }) =>
        $isHighlighted &&
        css`
            font-weight: bold;
            font-size: 12px;
            ${fontSecondary}
            color: ${colors.coral};
        `};
`
